import React, { useState, useEffect } from 'react';
import BurbujasLoader from '../../UIElements/BurbujasLoader';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, 
    FormControl, Input, Typography
} from '@mui/material';

const CambiarHorasModal = ({ open, onClose, onUpdate, loading, selectedRowData }) => {
    const [cantidadHoras, setCantidadHoras] = useState('');

    useEffect(() => {
        if (open && selectedRowData) {
            setCantidadHoras(selectedRowData.originalInstancia.cantidad_horas ?? selectedRowData.originalInstancia.detalle_curso?.cantidad_horas ?? '');
        } else if (!open) {
            setCantidadHoras('');
        }
    }, [open, selectedRowData]);

    const handleConfirm = () => {
        onUpdate({ cantidad_horas: cantidadHoras !== '' ? Number(cantidadHoras) : null });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Cambiar Cantidad de Horas</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>Curso: <strong>{selectedRowData?.["Nombre del curso"]}</strong></Typography>
                <Typography gutterBottom>Cantidad de Horas:</Typography>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <Input 
                        type="number"
                        value={cantidadHoras} 
                        onChange={(e) => setCantidadHoras(e.target.value)}
                        placeholder="Cantidad de horas"
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleConfirm} variant="contained" disabled={loading}>
                    {loading ? <BurbujasLoader small /> : "Confirmar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CambiarHorasModal;
